import { Form, Input, Button, notification } from 'antd';
import { Layout } from 'antd';
import { login as loginRequest } from '../../service/login';
import type { LoginRequest } from '../../service/login';
import type { LogInStatus } from '../../hooks/useLogin';
import { PageHeader } from '../components/Layout';
import styled from 'styled-components';
const { Content, Footer } = Layout;

const StyledAnchor = styled.a`
  color: rgba(var(--gray-6));
  text-decoration: none;
  &:hover {
    color: rgb(var(--arcoblue-5));
  }
`;

interface PropsType {
  loginSuccessRedirect: (status: LogInStatus) => void;
}

const Login = ({ loginSuccessRedirect }: PropsType) => {
  const login = async (values: LoginRequest) => {
    try {
      const { email, accesses } = await loginRequest(values);
      localStorage.setItem('username', email);
      localStorage.setItem('accesses', JSON.stringify(accesses));
      if (email && accesses) {
        loginSuccessRedirect({
          username: email,
          accesses,
        });
      }
    } catch (e) {
      notification.error({
        message: '登录失败，请重试',
      });
    }
  };
  return (
    <Layout style={{ height: '100vh' }}>
      <PageHeader />
      <Content
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Form
          style={{ width: '30%' }}
          onFinish={(values: LoginRequest) => {
            login(values);
          }}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
        >
          <Form.Item
            label="邮箱地址"
            name="email"
            rules={[{ required: true, message: '请输入邮箱地址' }]}
          >
            <Input></Input>
          </Form.Item>
          <Form.Item
            label="登录密码"
            name="password"
            rules={[{ required: true, message: '请输入登录密码' }]}
          >
            <Input.Password></Input.Password>
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button type="primary" htmlType="submit">
              登录
            </Button>
          </Form.Item>
        </Form>
      </Content>
      <Footer style={{ textAlign: 'center' }}>
        <div
          style={{
            color: 'rgba(var(--gray-6))',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {/* <img
            src="https://qcloudimg.tencent-cloud.cn/raw/eed02831a0e201b8d794c8282c40cf2e.png"
            style={{
              width: 14,
              height: 15,
              display: 'inline-block',
              marginRight: 6,
            }}
            alt="公安图标"
          ></img> */}
          <span>ICP备案号：</span>
          <StyledAnchor
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noreferrer"
          >
            苏ICP备2025160555号-1
          </StyledAnchor>
        </div>
      </Footer>
    </Layout>
  );
};

export default Login;
